import React, { Component } from 'react';
import { change, touch } from 'redux-form';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import DatePicker from '../../Common/DatePicker/DatePicker';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import messages from '../../../locale/messages';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { closeScheduledBookingModal } from '../../../actions/siteadmin/modalActions';
import { updateScheduleBooking } from '../../../actions/siteadmin/ManualBooking/updateScheduleBooking';
import bt from '../../../components/commonStyle.css';

class ScheduleBookingDate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      scheduleDate: null,
      scheduleHour: null,
      scheduleMinute: '',
      scheduleMeridiem: '',
      showDate: ''
    };
  }

  isDayBlocked = (date) => {
    let today = moment();
    let maximumDate = today.add(31, 'day');
    if (date > maximumDate) return true;
    return null
  }

  componentDidMount() {
    const { initialValues: { scheduleHour, scheduleMinute, scheduleMeridiem, scheduleDate } } = this.props;
    if (scheduleHour && scheduleMinute && scheduleMeridiem && scheduleDate) {
      this.setState({ scheduleHour, scheduleMinute, scheduleMeridiem, scheduleDate });
    }
  }

  handleDateChange = (date) => {
    this.setState({ scheduleDate: date });
  }

  handleTimeSelect = (e) => {
    this.setState({ [e.target.name]: e?.target?.value });
  }

  scheduleDateConvert = () => {
    const { scheduleDate, scheduleHour, scheduleMeridiem, scheduleMinute } = this.state;
    let scheduledHour, scheduleFrom;

    if (scheduleHour && scheduleMinute && scheduleMeridiem && scheduleDate) {
      scheduledHour = (scheduleMeridiem == 'PM' && scheduleHour < 12) ? Number(scheduleHour) + 12 : Number(scheduleHour);
      scheduledHour = (scheduleMeridiem == 'AM' && scheduleHour == 12) ? 0 : scheduledHour
      scheduleFrom = moment(scheduleDate).set({ h: scheduledHour, m: scheduleMinute });
    }
    return scheduleFrom ? scheduleFrom : null;
  }

  submitDate = async () => {
    const { change, closeScheduledBookingModal, updateScheduleBooking, bookingData, isViewPage, touch } = this.props;
    let variables = {}, scheduleFrom = this.scheduleDateConvert();

    if (isViewPage && bookingData) {
      const { bookingId, scheduleId, userId, refetch } = bookingData;
      if (!scheduleFrom) return showToaster({ messageId: 'selectData', toasterType: 'error' });
      scheduleFrom = moment(scheduleFrom).unix();
      await updateScheduleBooking({ bookingId, scheduleId, userId, scheduleFrom })
      variables = {
        id: bookingId
      }
      refetch && refetch(variables);
    }

    change('ManualBookingForm', 'scheduleFrom', scheduleFrom);
    touch('ManualBookingForm', 'scheduleFrom');
    closeScheduledBookingModal();
  }

  render() {
    const { scheduleDate, scheduleHour, scheduleMeridiem, scheduleMinute } = this.state;
    const { closeScheduledBookingModal, isViewPage, isLoading } = this.props;
    const { formatMessage, locale } = this.props.intl;
    let scheduleFrom, isAheadTime = false, isPastDate = false, hoursOption = [];
    let currentTime = moment().add(19, 'minutes'), today = moment();
    scheduleFrom = this.scheduleDateConvert();
    isAheadTime = scheduleFrom && currentTime > scheduleFrom
    isPastDate = scheduleFrom && today > scheduleFrom;
    hoursOption = Array.from({ length: 12 }).map((item, index) => {
      return { value: index + 1, label: `${((index + 1) < 10) ? '0' + (index + 1).toString() : (index + 1).toString()}` }
    });

    let minutesOption = Array.from({ length: 60 }).map((item, index) => {
      let minute = (index < 10) ? '0' + index.toString() : index.toString()
      return { value: minute, label: minute }
    })

    return (
      <div>
        <Form.Group >
          <label className={bt.commonLabelText}>{formatMessage(messages.date)}</label>
          <DatePicker
            placeholder={formatMessage(messages.selectDate)}
            formName={'ManualBookingForm'}
            fieldName={'scheduleDate'}
            initialDate={scheduleDate}
            isDayBlocked={this.isDayBlocked}
            handleDateChange={this.handleDateChange}
            block={true}
            showClearDate={true}
            containerClassName={"adminSingleDatePickerContainer"}
          />
        </Form.Group>
        <Form.Group>
          <label className={bt.commonLabelText}>{formatMessage(messages.time)}</label>
          <div className={'scheduleBookingTimeContainer'}>
            <select name={'scheduleHour'} value={scheduleHour} onChange={(e) => { this.handleTimeSelect(e) }} className={cx(bt.formControlSelect, bt.removeFocus)}>
              {hoursOption.map((item) => <option value={item?.value}>{item?.label}</option>)}
            </select>
            <select name={'scheduleMinute'} value={scheduleMinute} onChange={(e) => { this.handleTimeSelect(e) }} className={cx(bt.formControlSelect, bt.removeFocus)}>
              {minutesOption.map((item) => <option value={item?.value}>{item?.label}</option>)}
            </select>
            <select name={'scheduleMeridiem'} value={scheduleMeridiem} onChange={(e) => { this.handleTimeSelect(e) }} className={cx(bt.formControlSelect, bt.removeFocus)}>
              {['AM', 'PM'].map((item) => <option value={item}>{formatMessage(messages[item.toLocaleLowerCase()])}</option>)}
            </select>
          </div>
          {isPastDate && <span className={bt.errorMessage}>{formatMessage(messages.selectPastDate)}</span>}
          {isAheadTime && !isPastDate && <span className={bt.errorMessage}>{formatMessage(messages.scheduleAheadTime)}</span>}
        </Form.Group>
        {scheduleFrom && !isPastDate && !isAheadTime && <span className={cx(bt.bookingScheduleOnText)}>{`${formatMessage(messages.bookingScheduleOn)} ${moment(scheduleFrom).locale(locale).format(`ddd, MMM D, [${formatMessage(messages.at)}] h:mm A`)}`}</span>}
        <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
          <Button onClick={closeScheduledBookingModal} className={bt.btnSecondary}>
            {formatMessage(messages.cancelButton)}
          </Button>
          <Button onClick={this.submitDate} disabled={(isLoading || isAheadTime || isPastDate) && isViewPage} className={bt.btnPrimary}>
            {formatMessage(isViewPage ? messages.update : messages.done)}
          </Button>
        </div>
      </div >
    )
  }
}

const mapState = (state) => ({
  isLoading: state?.booking?.scheduledLoading
});

const mapDispatch = {
  change,
  touch,
  closeScheduledBookingModal,
  updateScheduleBooking
};

export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(ScheduleBookingDate)));
